import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { SITE_URL } from '@/lib/seo';

export default function AboutPage() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />

      <div className="pt-16 bg-background-50 border-b border-background-200">
        <div className="w-full px-4 md:px-8 lg:px-12 py-3">
          <nav aria-label="breadcrumb">
            <ol className="flex items-center gap-2 text-sm text-foreground-500">
              <li><a href="/" className="hover:text-primary-600 transition-colors">Home</a></li>
              <li><i className="ri-arrow-right-s-line text-xs" /></li>
              <li><span className="text-foreground-700">About</span></li>
            </ol>
          </nav>
        </div>
      </div>

      <main className="flex-1 w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 max-w-4xl mx-auto">
        <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6">About AllChinaBuy Spreadsheet</h1>
        <div className="prose prose-lg max-w-none text-foreground-700 leading-relaxed space-y-4">
          <p>
            AllChinaBuy Spreadsheet is an independent informational resource created to help buyers
            navigate the world of international e-commerce through the AllChinaBuy platform. We are not
            affiliated with AllChinaBuy unless explicitly stated, and all information provided is for
            educational purposes only.
          </p>
          <p>
            Our mission is to provide honest, comprehensive, and practical guides that help buyers make
            informed decisions. We cover topics ranging from product research and seller verification to
            shipping costs, quality control, and safety considerations.
          </p>
          <p>
            This website serves as a starting point for your research. We encourage all users to verify
            information independently and make decisions based on their own research and judgment.
          </p>
          <div className="mt-8 p-6 bg-primary-50 rounded-xl border border-primary-100">
            <h3 className="text-lg font-semibold text-primary-900 mb-2">Our Commitment</h3>
            <ul className="space-y-2 text-foreground-600">
              <li>Independent and unbiased information</li>
              <li>Regularly updated content</li>
              <li>Practical buying guidance</li>
              <li>Transparent disclosure of affiliate relationships</li>
            </ul>
          </div>
        </div>
      </main>

      <Footer />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "name": "About AllChinaBuy Spreadsheet",
          "url": `${SITE_URL}/about/`,
          "description": "Learn about AllChinaBuy Spreadsheet, an independent resource for product discovery, seller research, QC tips and shipping guidance."
        })}
      </script>
    </div>
  );
}